import { FormProvider } from '@slal/ui/react-hook-form/core';
import { Field, FieldSet, RadioFieldGroup } from '@slal/ui/react-hook-form/fields';
import { Article, Heading, P } from '@slal/ui/typography';
import { MaxWidthContent, StyledForm, yesOrNoOptions } from '~/components';
import { ApplicationButtons } from '~/features';
import { SelectedYesNoContent } from './SelectedYesNoContent';
import { useKeyConsiderationsApplicationForm } from './hooks';

const YesContent = () => {
    return (
        <Article>
            <Heading level={5}>Excellent. But did you know that your contributions allowance may drop?</Heading>
            <P>
                When taking more than your tax-free cash, the maximum that you or an employer can pay into any of your
                defined contribution pensions, without attracting a tax charge, will reduce to £10,000 a year with no
                carry forward.
            </P>
            <P>
                If you are taking more than your tax-free allowance, then it's likely that you'll initially pay an
                emergency tax rate on that money. Any overpaid tax can be reclaimed later.
            </P>
        </Article>
    );
};

const NoContent = () => {
    return (
        <Article>
            <Heading level={5}>Thanks, that makes things easier.</Heading>
            <P>
                When taking more than your tax-free cash, the maximum that you can pay into any of your defined
                contribution pensions normally reduces.
            </P>
            <P>
                Once this reduction occurs you can't change your mind later, so it's worth thinking about if you might
                want to start contributing again in the future.
            </P>
        </Article>
    );
};

export const ContinueContributingForm = () => {
    const { form, handleSubmit, name, option } = useKeyConsiderationsApplicationForm(
        'continueContributing',
        '/application/key-considerations/still-invested'
    );

    return (
        <MaxWidthContent>
            <FormProvider {...form}>
                <StyledForm onSubmit={handleSubmit}>
                    <FieldSet aria-label="Continue contributing">
                        <Field errorFor={name}>
                            <RadioFieldGroup name={name} options={yesOrNoOptions} stacked />
                        </Field>
                    </FieldSet>
                    {option && (
                        <SelectedYesNoContent option={option} YesContent={<YesContent />} NoContent={<NoContent />} />
                    )}
                    <ApplicationButtons backTo="/application/key-considerations/means-tested-benefits" />
                </StyledForm>
            </FormProvider>
        </MaxWidthContent>
    );
};
